// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1amjn","title":"ClientCherryInfo_title__3W6oi","itemText":"ClientCherryInfo_itemText__1C1OQ"};